import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./styles.css";
import App from "./App";

// Sentry — init before anything else so errors during mount are captured.
// DSN is a public credential by Sentry's design (baked into client bundles).
const dsn = import.meta.env.VITE_SENTRY_DSN;
if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? "dev",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Full-stack tracing — Sentry auto-propagates sentry-trace + baggage
    // headers to our API Gateway origin (CORS headers allowlisted on the
    // backend). Tune down for prod.
    tracesSampleRate: import.meta.env.VITE_SENTRY_ENVIRONMENT === "prod" ? 0.05 : 0.2,
    tracePropagationTargets: [
      /^https:\/\/[a-z0-9]+\.execute-api\.[a-z0-9-]+\.amazonaws\.com/,
      /^https:\/\/api(?:\.dev)?\.mdm\.meridianeventtech\.com/,
    ],
    // Session replay — always record when there's an error; light sample otherwise.
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    sendDefaultPii: true,
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
